module.exports = __webpack_public_path__ + "static/media/6_a2.f108133b.png";